import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { getStatusClient } from '../state/client/client.selectors'
import { filter, map, take, first } from 'rxjs'
import { RedirectToken } from '../tokens/tokens'
import { AuthService } from './auth.service'
import { ClientActions } from '../state/client/client.actions'

export const deferredAuthGuard: CanActivateFn = () => {
	const store = inject(Store)
	const router = inject(Router)
	const redirectPage = inject(RedirectToken)
	const authService = inject(AuthService)

	// Se nao tem token no localStorage, redireciona imediatamente
	const { token, clientId } = authService.getClientIdAndToken()
	if (!token || !clientId) {
		return router.createUrlTree([redirectPage])
	}

	// Verifica o status atual ANTES de criar o observable
	// Se estiver idle, dispara o loadClient uma unica vez
	store
		.select(getStatusClient)
		.pipe(first())
		.subscribe(status => {
			if (status === 'idle') {
				store.dispatch(ClientActions.loadClient({ id: clientId }))
			}
		})

	// Aguarda o loginStatus sair de 'idle'/'pending' e verifica o resultado
	return store.select(getStatusClient).pipe(
		filter(status => status !== 'idle' && status !== 'pending'),
		take(1),
		map(status => {
			if (status === 'success') {
				return true
			}
			return router.createUrlTree([redirectPage])
		})
	)
}
